import { render, staticRenderFns } from "./ProductDetailsQr.vue?vue&type=template&id=2a8eec2e&scoped=true"
import script from "./ProductDetailsQr.vue?vue&type=script&lang=js"
export * from "./ProductDetailsQr.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsQr.vue?vue&type=style&index=0&id=2a8eec2e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8eec2e",
  null
  
)

export default component.exports